module.exports = __webpack_public_path__ + "static/MarisaRomaHersonMDPhDAUSTRALIA-9c9a0a88d946408cc3f2c69ab3697ef1.jpg";